import React, {Component} from 'react';
import HowItWorks from './HowItWorks.js';
import DentalHealth from './DentalHealth.js';
import Products from './Products.js';
import About from './About.js';
import Home from './Home.js';
import Header from './Header.js';
import Footer from './Footer.js';

class PageRoutes extends Component{

    render(){
        var page = [];
        switch(this.props.Page){
            case "home":
                page.push(<Home Settings = {this.props.Settings} Content = {this.props.Content.pages[0].content} setPage = {this.props.setPage}/>)
                break;
            case "how-it-works":
                page.push(<HowItWorks Settings = {this.props.Settings} Content = {this.props.Content.pages[1].content} setPage = {this.props.setPage}/>)
                break;
            case "dental-health":
                page.push(<DentalHealth Settings = {this.props.Settings} Content = {this.props.Content.pages[2].content} setPage = {this.props.setPage}/>)
                break;
            case "products":
                page.push(<Products Settings = {this.props.Settings} Content = {this.props.Content.pages[3].content} setPage = {this.props.setPage} Products = {this.props.Content.pages[3].products} />)
                break;
            case "about":
                page.push(<About Settings = {this.props.Settings} Content = {this.props.Content.pages[4].content} setPage = {this.props.setPage}/>)
                break;
            default:
                page.push(<Home Settings = {this.props.Settings} Content = {this.props.Content.pages[0].content} setPage = {this.props.setPage}/>)
                break;
        }


        return(
                <div>
                    <Header  Content = {this.props.Content}
                             Settings = {this.props.Settings}
                             Page = {this.props.Page}
                             setPage = {this.props.setPage}
                             setCountry = {this.props.setCountry}
                             setLanguage = {this.props.setLanguage}
                    />
                    {page}
                    <Footer Settings = {this.props.Settings} Content = {this.props.Content.footer} />
                </div>

        )

    }

}

export default PageRoutes;



// WEBPACK FOOTER //
// ./src/components/PageRoutes.js